import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-454d2645"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Story absolute inset-0 overflow-hidden pointer-events-none" };
const _hoisted_2 = { class: "relative size-full isolate" };
import { toRef, computed, onMounted, onBeforeUnmount } from "vue";
import Delay from "@/core/Delay";
import AppService from "@/services/AppService";
import Viewport from "@/store/modules/Viewport";
import Hotspots from "@/store/modules/Hotspots";
import Teleports from "@/store/modules/Teleports";
import TpButton from "@/webgl/entities/Buttons/TpButton";
import { useStoryContext, useStoryState, } from "@/services/Composition";
import { HotSpotMediaType, getSceneHotspotType } from "@/config/content";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Story',
    setup(__props) {
        const { state: storyState } = useStoryState();
        const currentStoryState = computed(() => storyState.value.value);
        const currentChapter = useStoryContext("chapter");
        const currentScene = useStoryContext("scene");
        const isMenuOpen = useStoryContext("isMenuOpen");
        const currentHotspotId = useStoryContext("currHotspotId");
        const isStory = computed(() => storyState.value.matches("story.scene"));
        const isStoryMedia = computed(() => storyState.value.matches("story.scene.media"));
        const showStoryMedia = computed(() => storyState.value.matches("story.scene.media.default"));
        const currentSceneHotspotType = computed(() => getSceneHotspotType(currentChapter.value, currentScene.value, currentHotspotId.value));
        const isStoryHotspotMap = computed(() => [HotSpotMediaType.MAP, HotSpotMediaType.MAP_1, HotSpotMediaType.MAP_EUROPE].includes(currentSceneHotspotType.value));
        const isStoryHotspotSlider = computed(() => HotSpotMediaType.MEDIA === currentSceneHotspotType.value);
        // const canGoNext = computed(
        //   () =>
        //     storyState.value.matches("title") ||
        //     (storyState.value.matches("story.scene.default") &&
        //       storyState.value.context.canGoNext)
        // );
        const canSkip = computed(() => storyState.value.can("SKIP") || storyState.value.matches("story.scene.default.playing.showContinue"));
        const hotspots = toRef(Hotspots, "list");
        const teleport = toRef(Teleports, "tp");
        const { send } = useStoryState();
        const next = () => {
            const action = currentStoryState.value === "title"
                ? "NEXT"
                : "NEXT_SCENE";
            send(action);
        };
        const skip = () => send("SKIP");
        const openMedia = async (id) => {
            if (Viewport.isMobile) {
                AppService.glapp.stop();
                await Delay(100);
            }
            send({ type: "OPEN_MEDIA", id });
        };
        const closeMedia = () => {
            if (Viewport.isMobile)
                AppService.glapp.start();
            send("CLOSE_MEDIA");
        };
        const closeMenu = () => send("CLOSE_MENU");
        const hoverTp = () => {
            TpButton.hoverValue = 1;
        };
        const leaveTp = () => {
            TpButton.hoverValue = 0;
        };
        let watchState;
        onMounted(() => {
            watchState = AppService.state.subscribe(leaveTp);
        });
        onBeforeUnmount(() => {
            watchState === null || watchState === void 0 ? void 0 : watchState.unsubscribe();
        });
        return (_ctx, _cache) => {
            const _component_UIBtn = _resolveComponent("UIBtn");
            const _component_UIRoundCta = _resolveComponent("UIRoundCta");
            const _component_StoryMap = _resolveComponent("StoryMap");
            const _component_StorySlider = _resolveComponent("StorySlider");
            const _component_StoryMenu = _resolveComponent("StoryMenu");
            const _directive_sound = _resolveDirective("sound");
            const _directive_cursor = _resolveDirective("cursor");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    (canSkip.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "absolute inset-0 flex flex-col items-center justify-end pb-80 pointer-events-auto",
                            onClick: _cache[0] || (_cache[0] = ($event) => (!_unref(Viewport).isTouch && skip()))
                        }, [
                            (_unref(Viewport).isTouch)
                                ? (_openBlock(), _createBlock(_component_UIBtn, {
                                    key: 0,
                                    variant: "solid",
                                    theme: "light",
                                    sound: _unref(Viewport).isMobile ? 'UI_CLICK' : 'UI_SECONDARY_CLICK',
                                    onClick: skip
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(Viewport).isMobile ? _ctx.$t("global.continue") : _ctx.$t("global.skip")), 1)
                                    ]),
                                    _: 1
                                }, 8, ["sound"]))
                                : _createCommentVNode("", true)
                        ])), [
                            [
                                _directive_sound,
                                _unref(Viewport).isTouch ? false : 'UI_SECONDARY_CLICK',
                                void 0,
                                { click: true }
                            ]
                        ])
                        : _createCommentVNode("", true),
                    (isStory.value)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(hotspots.value, ({ id, position }) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: id,
                                class: "absolute top-0 left-0 flex justify-center items-center size-0",
                                style: _normalizeStyle({
                                    transform: `translate(${position[0]}px, ${position[1]}px)`,
                                })
                            }, [
                                _createVNode(_component_UIRoundCta, {
                                    class: "SceneHotspot pointer-events-auto",
                                    text: _ctx.$t('scene.hotspot.cta'),
                                    hover: _unref(Viewport).isTouch,
                                    onClick: ($event) => (openMedia(id))
                                }, null, 8, ["text", "hover", "onClick"])
                            ], 4));
                        }), 128))
                        : _createCommentVNode("", true),
                    (teleport.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "absolute top-0 left-0 flex justify-center items-center size-0",
                            style: _normalizeStyle({ transform: `translate(${teleport.value.position[0]}px, ${teleport.value.position[1]}px)` })
                        }, [
                            _withDirectives(_createElementVNode("button", {
                                class: "flex-none size-80 lg:size-152 pointer-events-auto",
                                onMouseenter: _cache[1] || (_cache[1] = ($event) => (!_unref(Viewport).isTouch && hoverTp())),
                                onMouseleave: _cache[2] || (_cache[2] = ($event) => (!_unref(Viewport).isTouch && leaveTp())),
                                onClick: next
                            }, null, 544), [
                                [
                                    _directive_cursor,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ],
                                [
                                    _directive_sound,
                                    void 0,
                                    void 0,
                                    {
                                        hover: true,
                                        click: true
                                    }
                                ]
                            ])
                        ], 4))
                        : _createCommentVNode("", true)
                ], 512), [
                    [_vShow, !showStoryMedia.value]
                ]),
                (isStoryMedia.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (isStoryHotspotMap.value)
                            ? (_openBlock(), _createBlock(_component_StoryMap, {
                                key: 0,
                                show: showStoryMedia.value,
                                onClose: closeMedia
                            }, null, 8, ["show"]))
                            : _createCommentVNode("", true),
                        (isStoryHotspotSlider.value)
                            ? (_openBlock(), _createBlock(_component_StorySlider, {
                                key: 1,
                                show: showStoryMedia.value,
                                onClose: closeMedia
                            }, null, 8, ["show"]))
                            : _createCommentVNode("", true)
                    ], 64))
                    : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_StoryMenu, { onClose: closeMenu }, null, 512), [
                    [_vShow, _unref(isMenuOpen)]
                ])
            ]));
        };
    }
});
